export default{
    namespaced: true,

    state:{
        /* Para el listado del paciente */
        pacientesList:[],
        total:0,
        // Para el paginado
        page:1,

        params:{},
        
    },
    mutations:{
        CAMBIA_LISTA_PACIENTES(state, data){
            //console.log(data.root)
            state.pacientesList = data.root
            state.total = data.total
        },
        CAMBIA_PARAMS_BUSCA(state, data){
            state.pacienteBuscaParams = data
        },
        CAMBIA_PAGE(state, data){
            state.page = data
        },

    },
    actions:{
        //
    },
    getters:{
        //
    },
}